export default "__VITE_ASSET__277a0581__"